import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');

export default class ManageTask extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
				let parms = "";
// 				JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state={
			task : {
				  "tasksId":0,
				  "taskName":"",
				  "ownerUserId":0,
				  "securityContextId":0,
				  "taskStatusCode":0,
				  "taskPriorityCode":0,
				  "taskPercComplete":0,
				  "task":"",
				  "taskDescription":"",
				  "taskAttachments":"",
				  "taskParticipants":"",
				  "alertFlag":false,
				  "reminderFlag":false,
				  "taskDueDate":"",
				  "effectiveDate":"",
				  "expirationDate":"",
				  "createUser":0,
				  "createDate":"",
				  "lastUpdateUser":0,
				  "lastUpdateDate":"",
				  "projects":"",
				  "accountCode":0,
				  "totalHours":0,
				  "activityId":0,
				  "projectId":0,
				  "parentId":0
			},
			taskStatusList : [],
			taskPriorityList : []
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({
			[target.id] : target.value
		});
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
	  var url = `${global.config.apiServicesUrl}/tasks`;
//	  var idUrl = "http://os-dev.origosoftware.com:5100/next-id-generator/get-next/tasks/tasksId";
	
//	  axios.get(idUrl)
//		  .then(response => {
//			  this.setState({generalledgerId : response.data["nextId"]});
//		  
//			  //console.log("new category id = " + JSON.stringifyt(this.state.task.contentCategoriesObject.contentCategoryId));
//		
//			console.log("request object = " + JSON.stringify(this.state));
	  		this.state.task.lastUpdateUser = Number(this.props.userId);

			axios
			  .post(url, this.state)
			  .then(response2 => {
			console.log("response.data");
			console.log(response2.status +":"+response2.data.accountId);
			// && response2.data.contentFacadeId === this.state.task.contentFacadeId
			if (response2.status === 200 )
			{
				this.message = "Success";
			}
			else
			{
				 this.message = "Failed";
			}        
			console.log(this.message);
			 // 
			event.preventDefault();
			//response.send(this.message);
			
		  })
			  .catch(err => {
			 console.log("error - " + err);
		  });
			  console.log("message info - " + this.message); 
		this.handleClear();
			
		//});
		
		
			console.log("SetState Message info-"+this.contentFacadeTypeId);
			console.log("SetState Message info-"+this.contentFacadeName);
			
	 };
	 handleClear(){
		 this.setState({task : {}})
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }

	handleOnLoad = () => {

 		this.setState({task : {}});
 		
 			//resolve drop down lists
			{
				//taskPriorityList
				var url1 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/TASK_PRIORITY`;
					axios.get(url1)
					.then(response =>{
 					this.setState({taskPriorityList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
				//taskStatusList
				var url2 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/TASK_STATUS`;
					axios.get(url2)
					.then(response =>{
 					this.setState({taskStatusList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
			}		      	

	 }
	
	render(){
    return (
    				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle EHX</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">

	<form>
		<div class="container-fluid">
		<h4>Create Task</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Task Name</label>
		<input id="taskName" class="form-control input-medium col-sm-8" value={this.state.task.taskName} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Task Owner</label>
		<input id="ownerUserId" class="form-control input-medium col-sm-8" value={this.state.task.ownerUserId} onChange ={this.handleChange}/>
		</div>

			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Task Status</label>
			<select id="taskStatusCode" class="form-control input-medium col-sm-8" value={this.state.task.taskStatusCode} onChange ={this.handleChange}>
			{
				this.state.taskStatusList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
			</div>

			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Task Priority</label>
			<select id="taskPriorityCode" class="form-control input-medium col-sm-8" value={this.state.task.taskPriorityCode} onChange ={this.handleChange}>
			{
				this.state.taskPriorityList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
			</div>

			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >% Complete</label>
		<input id="projectId" class="form-control input-medium col-sm-8" value={this.state.task.taskPercComplete} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Details</label>
		<input id="desktopId" class="form-control input-medium col-sm-8" value={this.state.task.task} onChange ={this.handleChange}/>
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Description</label>
			<input id="taskDescr" class="form-control input-medium col-sm-8" value={this.state.task.taskDescription} onChange ={this.handleChange}/>
		</div>
		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Attachments</label>
			<input id="taskEntry" class="form-control input-medium col-sm-8" value={this.state.task.taskAttachments} onChange ={this.handleChange}/>
		</div>
		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Participants</label>
			<input id="taskEntry" class="form-control input-medium col-sm-8" value={this.state.task.taskParticipants} onChange ={this.handleChange}/>
		</div>
		
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Alert Flag</label>
			<input type="checkbox" id="taskAlertFlag" class="form-control input-medium col-sm-8" value={this.state.task.alertFlag} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Reminder Flag</label>
			<input type="checkbox" id="taskReminderFlag" class="form-control input-medium col-sm-8" value={this.state.task.reminderFlag} onChange ={this.handleChange}/>
			</div>
		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Due Date</label>
			<input id="taskEntryDate" class="form-control input-medium col-sm-8" value={this.state.task.taskDueDate} onChange ={this.handleChange}/>
		</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Effective Date</label>
			<input id="effectiveDate" class="form-control input-medium col-sm-8" value={this.state.task.effectiveDate} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Expiration Date</label>
			<input id="expirationDate" class="form-control input-medium col-sm-8" value={this.state.task.expirationDate} onChange ={this.handleChange}/>
			</div>

		

				<hr/>
							<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Created By</label>
		<input id="createUserName" class="form-control input-medium col-sm-2" value={this.state.createUser} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="createDate" class="form-control input-medium col-sm-2" value={String(this.state.task.createDate).substring(0,10)} />
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Last Updated By</label>
		<input id="lastUpdateUserName" class="form-control input-medium col-sm-2" value={this.state.lastUpdateUser} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="lastUpdateDate" class="form-control input-medium col-sm-2" value={String(this.state.task.lastUpdateDate).substring(0,10)} />
		</div>
		<hr />	
					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Create" onClick ={this.handleSubmit}>Create</button>&nbsp;
		</div>		
	</form>
	
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
			
	);
}
}